import { z } from 'zod';
import { MaxStepsSchema } from './settings.js';
export const UserSchema = z.object({
    id: z.string(),
    name: z.string().optional(),
    email: z.string().optional()
});
export const UserSettingsSchema = z.object({
    language: z.enum(['fr', 'en', 'auto']),
    // Opt-in for the experimental turn-summarization compaction. Omit to leave
    // unset (system default applies, conversation-level setting can still
    // override).
    summarizationEnabled: z.boolean().optional(),
    maxSteps: MaxStepsSchema.optional(),
    // Canonical id of the model new conversations start on. Unset means the
    // catalogue's default applies. A model that has since been retired is kept
    // rather than cleared: a withdrawal may be temporary, and a preference erased
    // in silence is a preference nobody notices losing.
    model: z.string().optional()
});
// In the request, `summarizationEnabled: null` means "clear the user-level
// opinion and fall back to the system default". `undefined` means "don't
// touch this field". The storage layer materialises both as the SQL NULL.
export const UpdateUserSettingsRequestSchema = UserSettingsSchema.partial().extend({
    summarizationEnabled: z.boolean().nullable().optional(),
    maxSteps: MaxStepsSchema.nullable().optional(),
    model: z.string().min(1).nullable().optional()
});
